module.exports = __webpack_public_path__ + "img/FullCover_Eng4.b8693da8.jpg";